import * as React from "react";
import * as AccordionPrimitive from "@radix-ui/react-accordion";
import { ChevronDownIcon } from "lucide-react";

import { cn } from "../../lib/utils";

function Accordion({ ...props }: React.ComponentProps<typeof AccordionPrimitive.Root>) {
  return <AccordionPrimitive.Root data-slot="accordion" {...props} />;
}

function AccordionItem({
  className,
  ...props
}: React.ComponentProps<typeof AccordionPrimitive.Item>) {
  return (
    <AccordionPrimitive.Item
      data-slot="accordion-item"
      className={cn("jobsite:border-b jobsite:last:border-b-0", className)}
      {...props}
    />
  );
}

function AccordionTrigger({
  className,
  children,
  ...props
}: React.ComponentProps<typeof AccordionPrimitive.Trigger>) {
  return (
    <AccordionPrimitive.Header className="jobsite:flex">
      <AccordionPrimitive.Trigger
        data-slot="accordion-trigger"
        className={cn(
          "jobsite:focus-visible:border-ring jobsite:focus-visible:ring-ring/50 jobsite:flex jobsite:flex-1 jobsite:items-start jobsite:justify-between jobsite:gap-4 jobsite:rounded-md jobsite:py-4 jobsite:text-left jobsite:text-sm jobsite:font-medium jobsite:transition-all jobsite:outline-none jobsite:focus-visible:ring-[3px] jobsite:disabled:pointer-events-none jobsite:disabled:opacity-50 jobsite:[&[data-state=open]>svg]:rotate-180",
          className,
        )}
        {...props}
      >
        {children}
        <ChevronDownIcon className="jobsite:text-muted-foreground jobsite:pointer-events-none jobsite:size-4 jobsite:shrink-0 jobsite:translate-y-0.5 jobsite:transition-transform jobsite:duration-200" />
      </AccordionPrimitive.Trigger>
    </AccordionPrimitive.Header>
  );
}

function AccordionContent({
  className,
  children,
  ...props
}: React.ComponentProps<typeof AccordionPrimitive.Content>) {
  return (
    <AccordionPrimitive.Content
      data-slot="accordion-content"
      className="jobsite:data-[state=closed]:animate-accordion-up jobsite:data-[state=open]:animate-accordion-down jobsite:overflow-hidden jobsite:text-sm"
      {...props}
    >
      <div className={cn("jobsite:pt-0 jobsite:pb-4", className)}>{children}</div>
    </AccordionPrimitive.Content>
  );
}

export { Accordion, AccordionItem, AccordionTrigger, AccordionContent };
